module.exports = "https://web-assets.ifttt.com/packs/media/home/about_services-70665242.svg";